import { Info, ReportProblem } from "@mui/icons-material";
import { FC, ReactNode } from "react";
import { EPI_COLORS } from "./epiColors";
import './EpiInfoBox.scss';

interface Props {
	variant: 'info' | 'warning';
	title?: string;
	children: ReactNode;
}

const EpiInfoBox: FC<Props> = ({ variant, title, children }) => {
	const color = variant === 'warning' ? EPI_COLORS.warning : EPI_COLORS.info;
	return (
		<div className="epi-info-box" style={{ borderColor: color }}>
			<span className="icone" style={{ color: color }}>
				{variant === 'warning' ? <ReportProblem /> : <Info />}
			</span>
			<div className="texto">
				{!!title && <strong style={{ color: color }}>{title}</strong>}
				{children}
			</div>
		</div>
	);
};

export default EpiInfoBox;
